import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { EmpresaSwitcher } from '../../lanz-ui';
import { useAuth } from '../../contexts/AuthContext';
import './Header.css';

const LINKS = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/nfse/emissor', label: 'NFSe Emissor' },
  { to: '/nfse/tomadas', label: 'NFSe Tomadas' },
  { to: '/agentes', label: 'Clientes e fornecedores' },
  { to: '/financeiro', label: 'Financeiro' },
  // Ajuda em preview/WIP — oculta do menu (acesso via /ajuda?preview=1)
  { to: '/perfil', label: 'Perfil', end: true },
  { to: '/configuracoes', label: 'Configurações' },
];

function Header() {
  const navigate = useNavigate();
  const { user, empresaAtual, selectEmpresa, canSwitchEmpresa, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleEmpresaChange = (empresaId) => {
    selectEmpresa(empresaId);
    window.location.reload();
  };

  return (
    <header className="nfse-header">
      <div className="nfse-header-brand">
        <img
          className="nfse-header-logo-img"
          src={`${process.env.PUBLIC_URL || ''}/brand/logo-nfseapp.png`}
          alt="NFSeApp"
        />
      </div>

      <nav className="nfse-header-nav">
        {LINKS.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            end={link.end}
            className={({ isActive }) => `nfse-nav-link${isActive ? ' active' : ''}`}
          >
            {link.label}
          </NavLink>
        ))}
      </nav>

      <div className="nfse-header-actions">
        {canSwitchEmpresa() && (
          <EmpresaSwitcher
            user={user}
            empresaAtual={empresaAtual}
            onEmpresaChange={handleEmpresaChange}
          />
        )}
        <button type="button" className="nfse-header-logout" onClick={handleLogout}>
          <i className="pi pi-sign-out" />
          Sair
        </button>
      </div>
    </header>
  );
}

export default Header;
